// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { updateOnlineCourseNotes } from '../../../apis/onlineCourse';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { updateOnlineCourseNoteActions } = actionCreatorsList;

const outputActions = {
  success: updateOnlineCourseNoteActions.success,
  failure: updateOnlineCourseNoteActions.failure
};

type RequestActionTypes = ActionType<
  typeof updateOnlineCourseNoteActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getOnlineCourseContentsDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(updateOnlineCourseNoteActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, noteId, message } = action.payload;
      // send api promise
      return updateOnlineCourseNotes(id, noteId, message)
        .then(response => {
          const notes = response.data.message.notes;
          const parsedNotes = parseCamelCase(notes).map((_note:any) => ({
            ..._note,
            message: _note.note,
            note: undefined
          }));
          // handle success case here
          return updateOnlineCourseNoteActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return updateOnlineCourseNoteActions.failure({ error });
        });
    })
  );
};

export { getOnlineCourseContentsDataEpic as default};
